import { render, staticRenderFns } from "./TokenIcon.vue?vue&type=template&id=1d55ef51&scoped=true&"
import script from "./TokenIcon.vue?vue&type=script&lang=js&"
export * from "./TokenIcon.vue?vue&type=script&lang=js&"
import style0 from "./TokenIcon.vue?vue&type=style&index=0&id=1d55ef51&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d55ef51",
  null
  
)

export default component.exports